module.exports = __webpack_public_path__ + "img/loginBanner.0285c211.png";